// extracted by mini-css-extract-plugin
export default {"activeNavLink":"Menu_activeNavLink__+C+zJ","container":"Menu_container__hnJYH","navLink":"Menu_navLink__QyDPM","button":"Menu_button__3d+Qj"};